import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import WinningContracts from "../../components/winning-contracts";

function WinningContractsPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Maximize Your Chances of Winning Contracts | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={"Maximize Your Chances of Winning Contracts"} t={t} />
      <WinningContracts />
    </>
  );
}

export default WinningContractsPage;
